import React from "react";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { FormHelperText } from "@mui/material";

const Dropdown = ({
  label,
  options,
  handleChange,
  className,
  value,
  error = false,
  errorMessage = "",
  name = "",
}) => {
  return (
    <FormControl fullWidth className={className}>
      <InputLabel id="demo-simple-select-label">{label}</InputLabel>
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        name={name}
        // value={age}
        label={label}
        value={value}
        onChange={handleChange}
        error={error}
      >
        {options?.map((option) => (
          <MenuItem value={option?.id}>{option?.type?.replace("_"," ")}</MenuItem>
        ))}
      </Select>
      <FormHelperText>{errorMessage}</FormHelperText>
    </FormControl>
  );
};

export default Dropdown;
